import { useOne } from '@refinedev/core';
import { DynamicUiEntityLayout } from 'src/UI/dynamicUI/types';

export default function useFinancialEntityLayout({ entityType }: { entityType?: string } = {}) {
  const { data, isLoading, isError, refetch } = useOne<DynamicUiEntityLayout>({
    resource: 'entities/financial-layout-bff',
    id: entityType,
  });

  return {
    layout: data?.data,
    isLoading,
    isError,
    refetch,
  };
}
